import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Alert, AlertTitle, Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import _ from 'lodash';
import constants from "./../Utils/constants.json"
import { addKECode, isEmail, isName, isPhone, removeFromStore } from '../Utils/fn';
import Select from 'react-select';
import useCart from '../../hooks/useCart';
import { currencyseperator } from '../Utils/functions';
import { setCartItems } from '../../store/cartItems';
import Popupdialog from '../Components/popupcomponent';
import Loadingspinner from '../Components/loading';
import { setAlert } from '../../store/alert';
import fetch from '../Utils/fetch';


function Checkoutpage() {
    const dispatch = useDispatch();
    const { user, loggedIn } = useSelector((state) => state.user);
    const webSettings = useSelector(state => state.webSettings.data);
    const subProducts = useSelector((state) => state.subProducts.data);
    const cartItems = useSelector(state => state.cartItems.data);
    const { items, quantity, total } = useCart(cartItems);
    const [locationsarray, setlocationsarray] = useState([]);

    const [loading, setLoading] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);
    const [showconfirmorder, setshowconfirmorder] = useState(false);

    const [name, setName] = useState(user.LEDGER_NAME || '');
    const [phone, setPhone] = useState(user.CONTACT_PHONE ? user.CONTACT_PHONE.replace('+', '') : '254');
    const [email, setEmail] = useState(user.EMAIL_ADDRESS || '');
    const [branch, setBranch] = useState('');
    const [location, setLocation] = useState(user.ADDRESS || '');
    const [comments, setComments] = useState('');



    const [requestmade, setrequestmade] = useState(false);
    const [orderResponse, setOrderResponse] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        setlocationsarray(webSettings.locations.map((obj) => ({ label: obj.locationName, value: obj.mainLocation })))
    }, []);

    function clearCartItems() {
        removeFromStore(constants.CART_ITEMS);
        dispatch(setCartItems([]));
    }

    function submit(e) {
        setshowconfirmorder(false)
        if (loading) {
            dispatch(setAlert({ type: 'error', message: 'Please wait!!' }));
            return;
        }
        let res;

        if ((res = isName(name)) === true) {
            if ((res = isPhone(phone)) === true) {
                if ((res = isEmail(email)) === true) {
                    if (location.length > 3) {
                        setPhone(addKECode(phone));
                        setLoading(true);
                        dispatch(setAlert('Placing order. Please wait'));
                        let cart_items = [];
                        cartItems.forEach((item, index) => {
                            let obj = {};
                            obj.suom = item.suom;
                            obj.item_code = item.item_code;
                            obj.item_price = parseFloat(item.itemPrice);
                            obj.item_name = item.item_name;
                            obj.quantity = item.quantity;
                            obj.amount_value = parseFloat((parseFloat(item.itemPrice) * item.quantity).toFixed(2));
                            cart_items.push(obj);
                        });
                        fetch
                            .get('completeOfflineOrder', {
                                client_name: name,
                                email,
                                phone: addKECode(phone),
                                branch,
                                pick_location: location,
                                ledger_number: loggedIn ? user.LEDGER_NUMBER : 'GUEST',
                                comment: comments,
                                cart_items: JSON.stringify(cart_items),
                            })
                            .then((res) => {
                                if (res.list && res.list[0]) {
                                    setOrderResponse(res.list[0]);
                                    clearCartItems();
                                    lipaNaMpesa(res.list[0])
                                    dispatch(setAlert('Done placing order'));
                                }
                            })
                            .catch((err) => {
                                setLoading(false);
                                dispatch(setAlert({ type: 'error', message: 'Error checking out. ' + err.message }));
                            });
                        return;
                    } else {
                        res = 'Pick up location is required or too short';
                    }
                }
            }
        }
        dispatch(setAlert({ type: 'error', message: res }));
    }

    function lipaNaMpesa(tempmpesadata) {
        const finalempesadata = {
            name: name,
            order_no: tempmpesadata.ORDER_NUMBER.toString(),
            order_type: tempmpesadata.ORDER_TYPE.toString(),
            amount: tempmpesadata.AMOUNT.toString(),
            phone_number: addKECode(phone).toString(),
        }
        fetch
            .post('pay-goods-online', finalempesadata)
            .then((res) => {
                setLoading(false)
                if ('object' === typeof res) {
                    if (res.error === false) {
                        res.message = 'Request accepted for processing. Please check your phone.';
                    }
                    setrequestmade(true)
                } else {
                    dispatch(setAlert({ type: 'error', message: 'Unknown error occurred performing operation.' }));
                }
            })
            .catch((err) => {
                dispatch(setAlert({ type: 'error', message: 'object' === typeof err ? err.message : err }));
                setLoading(false)
            });
    }


    const disable_button = cartItems?.length < 1 || !name || !phone || !email || !location || !branch || loading

    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Place your order"} withbackicon={true} />
            {loading && <Loadingspinner />}
            {showconfirmorder &&
                <Popupdialog
                    toptext={"Confirm Order!"}
                    question={"Are you sure you want to place this order?"}
                    oncancel={() => setshowconfirmorder(false)}
                    onsuccess={submit}
                    successtext={"Place Order"} />
            }
            <div className='pagemini' style={{ paddingTop: 3, paddingBottom: 3 }}>
                <div style={{ fontSize: 12, display: "flex", flexWrap: "wrap" }}>If you proceed you are automatically accepting our <a>Terms & Conditions</a></div>
                {orderResponse &&
                    <Alert severity="success" sx={{ mt: 2, borderRadius: 2 }}>
                        <AlertTitle>Success</AlertTitle>
                        Order #{orderResponse.ORDER_NUMBER} placed successfully. <br />
                        <b>Total: {webSettings.CURRENCY} {currencyseperator(orderResponse.AMOUNT)}</b><br />
                        Complete payment on phone <b>{addKECode(phone)}</b>
                    </Alert>
                }
            </div>
            {!orderResponse && (
                <>
                    <div className="cartsummarytitle">ORDER SUMMARY</div>
                    <div className='pagemini'>
                        <div className='wrapcheckouttitle'>
                            <div className='titleleft'>Item's total ({cartItems?.length})</div>
                            <div style={{ fontWeight: "bold", fontSize: 13 }}>{webSettings.CURRENCY} {currencyseperator(total)}</div>
                        </div>
                        <div className='wrapcheckouttitle'>
                            <div className='titleleft'>Delivery fees</div>
                            <div style={{ fontWeight: "bold", fontSize: 13 }}>__</div>
                        </div>
                        <hr />
                        <div className='wrapcheckouttitle'>
                            <div className='titleleft'>Total</div>
                            <div style={{ fontWeight: "bold", fontSize: 13 }}>{webSettings.CURRENCY} {currencyseperator(total)}</div>
                        </div>
                    </div>

                    <div className="cartsummarytitle">CUSTOMER DETAILS</div>
                    <div className='pagemini'>
                        <label className='label' htmlFor='name'>
                            Full Name *
                        </label>
                        <input onInput={(e) => setName(e.target.value)} className='input' type='text' id='name' value={name} placeholder="John Doe" />

                        <label className='label' htmlFor='phone'>
                            Phone Number *
                        </label>
                        <input onInput={(e) => setPhone(e.target.value)} className='input' type='text' id='phone' value={phone} placeholder="07XXXXXXXX" />

                        <label className='label' htmlFor='email'>
                            Email Address *
                        </label>
                        <input onInput={(e) => setEmail(e.target.value)} className='input' type='email' id='email' value={email} placeholder="john@example.com" />
                    </div>

                    <div className="cartsummarytitle">ADDRESS & DELIVERY</div>
                    <div className='pagemini'>
                        <label className='label' htmlFor='branch'>
                            Preferred Branch *
                        </label>
                        <div style={{ fontSize: 13 }}>
                            <Select required menuPlacement="auto" options={locationsarray} onChange={(e) => setBranch(e.value)} />
                        </div>
                        <label className='label' htmlFor='location'>
                            Pickup Location *
                        </label>
                        <input onInput={(e) => setLocation(e.target.value)} className='input' type='text' id='location' value={location} placeholder="Specific location details..." />

                        <label className='label' htmlFor='comments'>
                            Additional Comments
                        </label><br />
                        <textarea onInput={(e) => setComments(e.target.value)} className='input' id='comments' value={comments} placeholder="Any instructions?" rows={3} style={{ height: 'auto', padding: '10px' }} />
                    </div>

                    <div className='quantitypopupdiv'>
                        <Button onClick={() => setshowconfirmorder(true)} disabled={disable_button} sx={{ height: 50, borderRadius: '50px' }} fullWidth variant="contained">Confirm Order</Button>
                    </div>
                </>
            )}

            {orderResponse && (
                <div className='quantitypopupdiv'>
                    <Button onClick={() => lipaNaMpesa(orderResponse)} disabled={loading} sx={{ height: 50, borderRadius: '50px', mb: 2 }} fullWidth variant="contained" color="success">PAY VIA M-PESA NOW</Button>
                    <Button onClick={() => window.location.href = '/'} sx={{ height: 50, borderRadius: '50px' }} fullWidth variant="outlined">GO HOME</Button>
                </div>
            )}

        </div>
    );
}


export default Checkoutpage;
